import React from 'react';
import styles from './styles/styles.module.scss';

export const ShimmerWrapper = ({ className = '', children }) => {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={styles.animate} />
      {children}
    </div>
  );
};

const mkShimmer = baseClassName => ({ className }) => {
  return <div className={`${baseClassName} ${className}`} />;
};

export const ProfilePhotoShimmer = mkShimmer(styles.profilePhoto);
export const TextShimmer = mkShimmer(styles.text);
export const ContentBlock = mkShimmer(styles.contentBlock);
